var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.$t("suggestions"),
      rightButtonText: _vm.actionText,
      rightMethod: _vm.onSubmitted,
      medium: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u(
      [
        {
          key: "input",
          fn: function() {
            return [
              _c(
                "v-container",
                [
                  _vm._t("inputText"),
                  _vm._v(" "),
                  !_vm.name
                    ? _c(
                        "v-flex",
                        { attrs: { sm6: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "required_field",
                            attrs: {
                              label: _vm.$t("name"),
                              rules: [_vm.fieldIsRequired("name")]
                            },
                            model: {
                              value: _vm.nameLocal,
                              callback: function($$v) {
                                _vm.nameLocal = $$v
                              },
                              expression: "nameLocal"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { sm6: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "required_field",
                        attrs: {
                          label: _vm.$t("email"),
                          rules: [
                            _vm.fieldIsRequired("email"),
                            _vm.fieldIsEmail()
                          ]
                        },
                        model: {
                          value: _vm.emailLocal,
                          callback: function($$v) {
                            _vm.emailLocal = $$v
                          },
                          expression: "emailLocal"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    [
                      _c("v-textarea", {
                        staticClass: "thinBox required_field",
                        attrs: {
                          label: _vm.$t("suggestion"),
                          rules: [_vm.fieldIsRequired("suggestion content")],
                          outline: "",
                          rows: "8"
                        },
                        model: {
                          value: _vm.comment,
                          callback: function($$v) {
                            _vm.comment = $$v
                          },
                          expression: "comment"
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    ),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62ad48ad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62ad48ad","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SuggestionsPopup.vue
// module id = null
// module chunks = 